var SearchApp = window.SearchApp || {};

SearchApp.PopupWidget = function(url, decodeService, $popupContainer, $popup, $input, $resultContainer) {
	SearchApp.Widget.call(this, url, decodeService, $input, $resultContainer);

	// Constants
	var POPUP_MARGIN = 30;

	// Public Overrides
	var base = $.extend({}, this);
	this.showSearchResults = showSearchResults;
	this.showSuggestions = showSuggestions;

	// Constructor
	activate();
	function activate() {
		assert($popupContainer instanceof jQuery, '$popupContainer is not a jQuery');
		assert($popup instanceof jQuery, '$popup is not a jQuery');
	}

	// Private Methods
	function showSuggestions() {
		base.showSuggestions();

		$popupContainer.modal('show');
	}

	function showSearchResults(query, result) {
		base.showSearchResults(query, result);

		updateLayout();
	}

	function updateLayout() {
		var $tableContainer = $resultContainer.find('.table-container');

		var padding = $popup.height() - $tableContainer.height();
		var maxHeight = $popupContainer.height() - 2 * POPUP_MARGIN - padding;

		$tableContainer.css({maxHeight: maxHeight});
	}
};
